import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import axiosInstance from '../api/axiosInstance';
import { login } from '../actions/authActions';
import {
    User,
    UserPlus,
    Smartphone,
    IdCard,
    Lock,
    ShieldCheck,
    Phone,
} from 'lucide-react';
import { isAuthBypassEnabled } from '../components/ProtectedRoute';

const Home = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const inputRefs = useRef([]);

    const [activeTab, setActiveTab] = useState('login');
    const [loginMethod, setLoginMethod] = useState('mobile');
    const [step, setStep] = useState('login');
    const [inputValue, setInputValue] = useState('');
    const [otpInput, setOtpInput] = useState(['', '', '', '', '', '']);
    const [mobileNumber, setMobileNumber] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [seconds, setSeconds] = useState(60);
    const [isResendEnabled, setIsResendEnabled] = useState(false);

    // Site selection disabled on login/registration — registration uses fixed PBMH site on backend.
    // const [isSiteSelected, setIsSiteSelected] = useState(false);
    // const [showSiteModal, setShowSiteModal] = useState(false);
    // const [branches, setBranches] = useState([]);
    // const [selectedBranchId, setSelectedBranchId] = useState('');
    // const [loadingBranches, setLoadingBranches] = useState(false);
    // const [branchError, setBranchError] = useState('');
    // const [selectedSiteName, setSelectedSiteName] = useState('');
    // const [pendingRegistration, setPendingRegistration] = useState(false);

    // const loadSelectedSiteFromStorage = useCallback(() => {
    //     const siteId = localStorage.getItem('site_id');
    //     const siteCode = localStorage.getItem('site_code');
    //     const hospitalName = localStorage.getItem('hospital_name');
    //     const hasSite = Boolean(siteId && siteCode);
    //     setIsSiteSelected(hasSite);
    //     setSelectedSiteName(hospitalName || siteCode || '');
    //     return hasSite;
    // }, []);

    // const fetchBranches = useCallback(async () => {
    //     setLoadingBranches(true);
    //     setBranchError('');
    //     try {
    //         const token = localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1');
    //         const response = await axios.get(
    //             `${process.env.REACT_APP_HIMS_API_URL}/baseadj/branch/master`,
    //             { headers: { Authorization: `Bearer ${token}` } }
    //         );
    //         if (response.data?.status === 'success' && Array.isArray(response.data.data)) {
    //             setBranches(response.data.data);
    //         } else {
    //             setBranchError('Unable to load sites. Please try again.');
    //             setBranches([]);
    //         }
    //     } catch (err) {
    //         console.error('Error fetching branch master:', err);
    //         setBranchError('Failed to load sites. Please try again.');
    //         setBranches([]);
    //     } finally {
    //         setLoadingBranches(false);
    //     }
    // }, []);

    // useEffect(() => {
    //     loadSelectedSiteFromStorage();
    //     fetchBranches();
    // }, [loadSelectedSiteFromStorage, fetchBranches]);

    useEffect(() => {
        if (location.state?.showOTP && location.state?.mobileNumber) {
            setActiveTab('login');
            setMobileNumber(location.state.mobileNumber);
            setInputValue(location.state.mobileNumber);
            setStep('otp');
            setSeconds(60);
            setIsResendEnabled(false);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location, navigate]);

    useEffect(() => {
        if (step === 'otp' && seconds > 0) {
            const timer = setInterval(() => setSeconds((prev) => prev - 1), 1000);
            return () => clearInterval(timer);
        }
        if (seconds === 0) setIsResendEnabled(true);
    }, [seconds, step]);

    // const getBranchLabel = (branch) => {
    //     const code = branch.SiteCode || branch.siteCode || '';
    //     const name = branch.hospitalName || '';
    //     const locationLabel = branch.location || '';
    //     if (name && locationLabel) return `${name} (${code}) - ${locationLabel}`;
    //     if (name) return `${name} (${code})`;
    //     return code || `Site ${branch.siteId}`;
    // };

    // const openSiteModal = () => {
    //     const currentSiteId = localStorage.getItem('site_id');
    //     setSelectedBranchId(currentSiteId || '');
    //     setBranchError('');
    //     setShowSiteModal(true);
    //     if (branches.length === 0) fetchBranches();
    // };

    // const handleSiteConfirm = () => {
    //     const branch = branches.find((item) => String(item.siteId) === String(selectedBranchId));
    //     if (!branch) {
    //         setBranchError('Please select a site to continue.');
    //         return;
    //     }
    //     localStorage.setItem('site_id', String(branch.siteId));
    //     localStorage.setItem('site_code', branch.SiteCode || branch.siteCode || '');
    //     localStorage.setItem('hospital_name', branch.hospitalName || branch.SiteCode || branch.siteCode || '');
    //     setIsSiteSelected(true);
    //     setSelectedSiteName(branch.hospitalName || branch.SiteCode || branch.siteCode || '');
    //     setBranchError('');
    //     setShowSiteModal(false);
    //     if (pendingRegistration) {
    //         setPendingRegistration(false);
    //         navigate('/patient-details');
    //     }
    // };

    // const ensureSiteThen = (action) => {
    //     const siteId = localStorage.getItem('site_id');
    //     const siteCode = localStorage.getItem('site_code');
    //     if (!siteId || !siteCode) {
    //         setPendingRegistration(action === 'register');
    //         openSiteModal();
    //         return false;
    //     }
    //     return true;
    // };

    const handleTabChange = (tab) => {
        setError('');
        if (tab === 'register') {
            setActiveTab('register');
            // Site gate disabled — registration site is fixed to PBMH on backend
            navigate('/patient-details');
            return;
        }
        setActiveTab('login');
        setStep('login');
    };

    const handleLoginMethodChange = (method) => {
        setLoginMethod(method);
        setInputValue('');
        setError('');
    };

    const handleInputChange = (e) => {
        let value = e.target.value;
        if (loginMethod === 'mobile') {
            value = value.replace(/\D/g, '').slice(0, 10);
        }
        setInputValue(value);
        setError('');
    };

    const handleOtpChange = (event, index) => {
        const { value } = event.target;
        if (/[^0-9]/.test(value)) return;
        const newValue = [...otpInput];
        newValue[index] = value;
        setOtpInput(newValue);
        if (value.length === 1 && index < inputRefs.current.length - 1) {
            inputRefs.current[index + 1]?.focus();
        } else if (value.length === 0 && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
        setError('');
    };

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        // Site gate disabled on login
        // if (!ensureSiteThen('login')) return;

        if (loginMethod === 'mobile') {
            if (inputValue.length !== 10) {
                setError('Please enter a valid 10-digit mobile number.');
                return;
            }
        } else if (!inputValue.trim()) {
            setError('Please enter your MRN.');
            return;
        }

        setLoading(true);
        try {
            const response = await axiosInstance.post('/api/auth/send-otp-login', {
                mobileNumber: inputValue.trim(),
                hmisToken: localStorage.getItem('token'),
                registrationSiteCode: localStorage.getItem('site_code'),
            });

            if (response.status === 200 || response.status === 201) {
                // Always OTP next; profile selection (if multiple) happens after verify
                setMobileNumber(inputValue.trim());
                setStep('otp');
                setSeconds(60);
                setIsResendEnabled(false);
                setOtpInput(['', '', '', '', '', '']);
                setError('');
            } else {
                setError('Invalid mobile number or MRN.');
            }
        } catch (err) {
            console.error('Error sending OTP:', err);
            setError(
                err.response?.data?.error ||
                err.response?.data?.errors?.mobile ||
                'Failed to send OTP. Please try again.'
            );
        } finally {
            setLoading(false);
        }
    };

    const handleResendOTP = async () => {
        setLoading(true);
        try {
            await axiosInstance.post('/api/auth/send-otp-login', { mobileNumber });
            setSeconds(60);
            setIsResendEnabled(false);
            setOtpInput(['', '', '', '', '', '']);
            setError('');
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to resend OTP.');
        } finally {
            setLoading(false);
        }
    };

    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        const otp = otpInput.join('');
        if (otp.length !== 6) {
            setError('Please enter a valid 6-digit OTP.');
            return;
        }
        setLoading(true);
        try {
            const response = await axiosInstance.post('/api/auth/verify-otp-login', {
                mobileNumber,
                otp,
            });
            if (response.data.multipleProfiles) {
                navigate('/select-patient-profile', {
                    state: {
                        patients: response.data.patients,
                        mobileNumber: response.data.mobileNumber || mobileNumber,
                    },
                });
            } else {
                dispatch(login(response.data.kiosk_token));
                navigate('/dashboard', { replace: true });
            }
        } catch (err) {
            setError(
                err.response?.data?.errors?.otp ||
                err.response?.data?.errors?.general ||
                'Invalid OTP. Please try again.'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="relative min-h-screen overflow-hidden bg-[#E8F5EE]">
            {/* Soft decorative background */}
            <div className="pointer-events-none absolute inset-0" aria-hidden="true">
                <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-[#0FA968]/15" />
                <div className="absolute top-1/3 -right-20 h-80 w-80 rounded-full bg-[#0FA968]/10" />
                <div className="absolute -bottom-16 left-1/4 h-64 w-64 rounded-full bg-[#138F5E]/10" />
                <div
                    className="absolute left-8 top-8 h-24 w-24 opacity-30"
                    style={{
                        backgroundImage: 'radial-gradient(circle, #94A3B8 1.2px, transparent 1.2px)',
                        backgroundSize: '10px 10px',
                    }}
                />
            </div>

            {/* Site selection modal disabled on login/registration — restore with site state helpers above if needed */}

            <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-lg flex-col items-center justify-center px-4 py-8 sm:py-12">
                <img
                    src="/logo.jpg"
                    alt="KIMS Bhubaneswar"
                    className="mb-4 h-20 object-contain sm:mb-5 sm:h-24"
                />

                {/* Site selection UI disabled on login/registration
                <div className="mb-5 flex flex-wrap items-center justify-center gap-2">
                    {isSiteSelected ? (
                        <div className="inline-flex max-w-full items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs text-emerald-800 sm:text-sm">
                            <MapPin className="h-3.5 w-3.5 shrink-0" />
                            <span className="truncate">{selectedSiteName}</span>
                        </div>
                    ) : (
                        <div className="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-amber-50 px-3 py-1.5 text-xs text-amber-800 sm:text-sm">
                            <AlertCircle className="h-3.5 w-3.5 shrink-0" />
                            <span>Select hospital to continue</span>
                        </div>
                    )}
                    <button
                        type="button"
                        onClick={openSiteModal}
                        className="rounded-full bg-[#0FA968] px-3 py-1.5 text-xs font-medium text-white hover:bg-[#138F5E] sm:text-sm"
                    >
                        {isSiteSelected ? 'Change' : 'Select Site'}
                    </button>
                </div>
                */}

                <div className="w-full rounded-2xl bg-white p-5 shadow-xl sm:p-8">
                    {/* Tabs */}
                    <div className="mb-6 grid grid-cols-2 gap-2 sm:gap-3">
                        <button
                            type="button"
                            onClick={() => handleTabChange('login')}
                            className={`flex items-center justify-center gap-2 rounded-xl px-3 py-3 text-sm font-semibold transition sm:text-base ${
                                activeTab === 'login'
                                    ? 'bg-[#0B6B3A] text-white shadow-md'
                                    : 'border border-gray-200 bg-white text-gray-700 hover:bg-gray-50'
                            }`}
                        >
                            <User className="h-4 w-4 sm:h-5 sm:w-5" />
                            <span className="leading-tight">Existing User Login</span>
                        </button>
                        <button
                            type="button"
                            onClick={() => handleTabChange('register')}
                            className={`flex items-center justify-center gap-2 rounded-xl px-3 py-3 text-sm font-semibold transition sm:text-base ${
                                activeTab === 'register'
                                    ? 'bg-[#0B6B3A] text-white shadow-md'
                                    : 'border border-gray-200 bg-white text-gray-700 hover:bg-gray-50'
                            }`}
                        >
                            <UserPlus className="h-4 w-4 sm:h-5 sm:w-5" />
                            <span className="leading-tight">New User Registration</span>
                        </button>
                    </div>

                    {step === 'login' ? (
                        <form onSubmit={handleLoginSubmit}>
                            <p className="mb-3 text-center text-sm font-medium text-gray-500">Login Using</p>
                            <div className="mb-5 grid grid-cols-2 gap-3">
                                <button
                                    type="button"
                                    onClick={() => handleLoginMethodChange('mobile')}
                                    className={`flex items-center gap-2 rounded-xl border-2 px-3 py-3 text-left transition ${
                                        loginMethod === 'mobile'
                                            ? 'border-[#0FA968] bg-emerald-50'
                                            : 'border-gray-200 bg-white hover:border-gray-300'
                                    }`}
                                >
                                    <span
                                        className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 ${
                                            loginMethod === 'mobile' ? 'border-[#0FA968]' : 'border-gray-300'
                                        }`}
                                    >
                                        {loginMethod === 'mobile' && (
                                            <span className="h-2 w-2 rounded-full bg-[#0FA968]" />
                                        )}
                                    </span>
                                    <Smartphone className={`h-4 w-4 ${loginMethod === 'mobile' ? 'text-[#0FA968]' : 'text-gray-500'}`} />
                                    <span className="text-sm font-medium text-gray-800">Mobile Number</span>
                                </button>
                                <button
                                    type="button"
                                    onClick={() => handleLoginMethodChange('mrn')}
                                    className={`flex items-center gap-2 rounded-xl border-2 px-3 py-3 text-left transition ${
                                        loginMethod === 'mrn'
                                            ? 'border-[#0FA968] bg-emerald-50'
                                            : 'border-gray-200 bg-white hover:border-gray-300'
                                    }`}
                                >
                                    <span
                                        className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 ${
                                            loginMethod === 'mrn' ? 'border-[#0FA968]' : 'border-gray-300'
                                        }`}
                                    >
                                        {loginMethod === 'mrn' && (
                                            <span className="h-2 w-2 rounded-full bg-[#0FA968]" />
                                        )}
                                    </span>
                                    <IdCard className={`h-4 w-4 ${loginMethod === 'mrn' ? 'text-[#0FA968]' : 'text-gray-500'}`} />
                                    <span className="text-sm font-medium text-gray-800">MRN</span>
                                </button>
                            </div>

                            <label htmlFor="login-input" className="mb-1.5 block text-sm font-medium text-gray-700">
                                {loginMethod === 'mobile' ? 'Mobile Number' : 'MRN'}{' '}
                                <span className="text-red-500">*</span>
                            </label>
                            <div className="relative mb-2">
                                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                    {loginMethod === 'mobile' ? (
                                        <Phone className="h-5 w-5 text-gray-400" />
                                    ) : (
                                        <IdCard className="h-5 w-5 text-gray-400" />
                                    )}
                                </div>
                                <input
                                    id="login-input"
                                    type="text"
                                    inputMode={loginMethod === 'mobile' ? 'numeric' : 'text'}
                                    value={inputValue}
                                    onChange={handleInputChange}
                                    disabled={loading}
                                    placeholder={
                                        loginMethod === 'mobile'
                                            ? 'Enter registered mobile number'
                                            : 'Enter your MRN'
                                    }
                                    className={`w-full rounded-xl border-2 bg-white py-3.5 pl-11 pr-4 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 ${
                                        error
                                            ? 'border-red-400 focus:border-red-400 focus:ring-red-100'
                                            : 'border-gray-200 focus:border-[#0FA968] focus:ring-emerald-100'
                                    }`}
                                    aria-invalid={Boolean(error)}
                                />
                            </div>
                            {error && <p className="mb-3 text-sm text-red-600">{error}</p>}

                            <button
                                type="submit"
                                disabled={loading}
                                className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl bg-[#0B6B3A] px-4 py-3.5 text-base font-semibold text-white shadow-md transition hover:bg-[#095730] disabled:cursor-not-allowed disabled:opacity-70"
                            >
                                {loading ? (
                                    <div className="h-6 w-6 animate-spin rounded-full border-4 border-white border-t-transparent" />
                                ) : (
                                    <>
                                        <Lock className="h-5 w-5" />
                                        Send OTP
                                    </>
                                )}
                            </button>
                        </form>
                    ) : (
                        <form onSubmit={handleOtpSubmit}>
                            <div className="mb-4 text-center">
                                <h3 className="text-lg font-semibold text-gray-900">Enter OTP</h3>
                                <p className="mt-1 text-sm text-gray-600">
                                    An OTP has been sent to your registered mobile number
                                </p>
                                {seconds > 0 && (
                                    <p className="mt-2 text-sm font-medium text-[#0FA968]">{seconds} sec</p>
                                )}
                            </div>
                            <div className="mb-4 flex justify-center gap-2 sm:gap-3">
                                {otpInput.map((value, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={1}
                                        ref={(el) => { inputRefs.current[index] = el; }}
                                        value={value}
                                        onChange={(e) => handleOtpChange(e, index)}
                                        disabled={loading}
                                        className={`h-12 w-10 rounded-lg border-2 text-center text-xl font-semibold focus:outline-none focus:ring-2 sm:h-14 sm:w-12 ${
                                            error
                                                ? 'border-red-400 focus:ring-red-100'
                                                : 'border-gray-200 focus:border-[#0FA968] focus:ring-emerald-100'
                                        }`}
                                        aria-label={`OTP digit ${index + 1}`}
                                    />
                                ))}
                            </div>
                            {error && <p className="mb-3 text-center text-sm text-red-600">{error}</p>}
                            <div className="mb-4 flex flex-col-reverse items-center gap-3 sm:flex-row sm:justify-between">
                                <button
                                    type="button"
                                    onClick={handleResendOTP}
                                    disabled={!isResendEnabled || loading}
                                    className={`text-sm font-medium ${
                                        isResendEnabled && !loading
                                            ? 'cursor-pointer text-[#0FA968] hover:underline'
                                            : 'cursor-not-allowed text-gray-400'
                                    }`}
                                >
                                    Resend OTP
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setStep('login');
                                        setOtpInput(['', '', '', '', '', '']);
                                        setError('');
                                    }}
                                    className="text-sm text-gray-500 hover:text-gray-700"
                                >
                                    Change number
                                </button>
                            </div>
                            <button
                                type="submit"
                                disabled={loading}
                                className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#0B6B3A] px-4 py-3.5 text-base font-semibold text-white shadow-md transition hover:bg-[#095730] disabled:opacity-70"
                            >
                                {loading ? (
                                    <div className="h-6 w-6 animate-spin rounded-full border-4 border-white border-t-transparent" />
                                ) : (
                                    'Verify OTP'
                                )}
                            </button>
                        </form>
                    )}

                    <div className="mt-6 rounded-xl border border-emerald-100 bg-[#F0FAF4] px-4 py-3">
                        <div className="flex items-start gap-3">
                            <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-[#0FA968]" />
                            <div>
                                <p className="text-sm font-semibold text-[#0B6B3A]">
                                    Your security is our priority
                                </p>
                                <p className="mt-0.5 text-xs text-gray-600 sm:text-sm">
                                    We use OTP verification to ensure secure access to your account.
                                </p>
                            </div>
                        </div>
                    </div>

                    {isAuthBypassEnabled() && (
                        <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50 p-4 text-center">
                            <p className="mb-3 text-xs font-medium text-amber-800">
                                TEMP: Auth bypass is ON — for UI preview only
                            </p>
                            <button
                                type="button"
                                onClick={() => navigate('/dashboard')}
                                className="w-full rounded-xl bg-amber-600 px-4 py-3 text-sm font-semibold text-white hover:bg-amber-700"
                            >
                                Open Patient Dashboard (Preview)
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Home;
